import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";

const name = 'util';

const initialState = {
    county: [],
    countyForFarms: [],
    banks: [],
    cropCategories: []
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setCounty(state, action) {
            state.county = json.toJSON(action.payload);
        },
        setCountyForFarms(state, action) {
            state.countyForFarms = json.toJSON(action.payload);
        },
        setBanks(state, action) {
            state.banks = json.toJSON(action.payload);
        },
        setCropCategories(state, action){
            state.cropCategories = json.toJSON(action.payload);
        }
    }
});

export const { setCounty, setBanks, setCropCategories, setCountyForFarms } = slice.actions;
const {reducer} = slice;

export const selectCounty = state => json.fromJSON(state[name].county);
export const selectCountyForFarms = state => json.fromJSON(state[name].countyForFarms);
export const selectBanks = state => json.fromJSON(state[name].banks);
export const selectCropCategories = state => json.fromJSON(state[name].cropCategories);

const utilReducer = reducer;
export default utilReducer;